import api from '@/api'
import Editable from '@/components/elements/Editable'
import uploadfile from '@/components/elements/uploadfile'
import config from '@/config'
import { calculateShippingPrice, getBangkokLocation } from '@/nvbb.js'
import axios from 'axios'
import $ from 'jquery'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import Nl2br from 'vue-nl2br'
import { mapGetters } from 'vuex'
import CityFreshShippingDate from './CityFreshShippingDate.vue'
import PrintAllCovers from './PrintAllCovers.vue'
import PrintAllCoversCentral from './PrintAllCoversCentral.vue'
import PrintCover from './PrintCover'
import SelectGmap from './SelectGmap'
import dtacGamingApi from '@/api/dtac-gaming'

import { ACOMMERCE_STATUS_OPTIONS, STATUS_OPTIONS } from '@/constants/acommerce.js'

export default {
  props: ['value', 'cbAll', 'shippingOptions', 'showProductDetail'],
  data: function () {
    return {
      phoneNumber: null,
      name: null,
      showToAddress: false,
      dataEdit: null,
      order_json: null,
      toggleDroppoint: false,
      toggleHub: false,
      droppointSelect: null,
      hubSelect: null,
      cb: false,
      showDetail: false,
      showPrint: false,
      status: {
        label: this.$t('ordered'),
        value: 'ordered',
        firstinit: true
      },
      statusPay: {
        label: this.$t('โอนเงิน'),
        value: 'payment',
        firstinit: true
      },
      nameEdit: null,
      driverRemark: null,
      shippingValue: '',
      cart_remark: '',
      orderToMove: null,
      showMoveToOrder: false,
      nvbb: {
        shippingAddress: '',
        showDatePicker: false,
        mindate: null,
        shippingType: null,
        pickupdate: null,
        hubLocation: null,
        hubLocationOptions: [
          {
            text: 'Smizzle Burger พระราม 4 - สุขุมวิท 26',
            value: 'พระราม 4 - สุขุมวิท 26',
            desc: `📍พระราม 4 - สุขุมวิท 26📍\n⭐️ Smizzle Burger\nอยู่ใน Bambini Villa Community Mall\n🕓 ช่วง 13:00-20:00 (02-0564336)`,
            link: 'https://goo.gl/maps/GXujUmxgoyha8xzR8'
          },
          {
            text: 'สนาม Flick FootBall วังทองหลาง - ลาดพร้าว',
            value: 'วังทองหลาง - ลาดพร้าว',
            desc: `📍วังทองหลาง - ลาดพร้าว 📍\n⭐️ สนาม Flick FootBall (ใกล้ Central EastVille 1 นาที)\n> ช่วง 14:00-21:30 (098-8892203)`,
            link: 'https://maps.app.goo.gl/qBvH8Ehnccsr689y7'
          },
          {
            text: 'ร้าน Sweet tooth พันท้ายนรสิงห์',
            value: 'พันท้ายนรสิงห์',
            desc: `📍พันท้ายนรสิงห์📍\n⭐️หมู่บ้านเดอะแกรนด์ ร้าน Sweet tooth\n🕓 ก่อน 9:00-17:00 (083-8886333)`
          },
          {
            text: 'ร้าน BAANTOON Cafe',
            value: 'บางบอน - บางแค',
            desc: `📍ใกล้กับ รพ.สมุทรสาคร📍\nร้าน BAANTOON Cafe\nCall : 034-423433`,
            link: 'https://goo.gl/maps/3t16hNmM86MA5yq56'
          }
        ],
        droppointLocationOptions: [
          {
            text: 'บางบอน-เอกชัย (PTT-BB3)',
            desc: `📍บางบอน-เอกชัย (PTT-BB3)📍`,
            value: 'บางบอน-เอกชัย (PTT-BB3)',
            location: [
              {
                lat_long: '13.656371920694491, 100.39405052096835',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop1',
            timePeriod: '10:00 - 15:00',
            displayString: '99, 99 ถ. เอกชัย แขวง บางบอน เขตบางบอน กรุงเทพมหานคร 10150'
          },
          {
            text: 'พุทธมณฑล-สนามหลวง 2 (LT)',
            desc: `📍พุทธมณฑล-สนามหลวง 2 (LT)📍`,
            value: 'พุทธมณฑล-สนามหลวง 2 (LT)',
            location: [
              {
                lat_long: '13.747239687663944, 100.35444366793094',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 20,
            filterName: 'drop2',
            timePeriod: '10:00 - 15:00',
            displayString: '76/4 ถนนทวีวัฒนา แขวงทวีวัฒนา เขตทวีวัฒนา, กรุงเทพมหานคร 10170'
          },
          {
            text: 'กาญจนาภิเษก (ES)',
            desc: `📍กาญจนาภิเษก (ES)📍`,
            value: 'กาญจนาภิเษก (ES)',
            location: [
              {
                lat_long: '13.776126053780834, 100.40910746731954',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop3',
            timePeriod: '10:00 - 15:00',
            displayString: '136, 4 ถ. กาญจนาภิเษก แขวง บางระมาด เขตตลิ่งชัน กรุงเทพมหานคร 10170'
          },
          {
            text: 'กาญจนาภิเษก (PT)',
            desc: `📍กาญจนาภิเษก (PT)📍`,
            value: 'กาญจนาภิเษก (PT)',
            location: [
              {
                lat_long: '13.670219396886246, 100.40551465678783',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop4',
            timePeriod: '10:00 - 15:00',
            displayString: '95/1 ถ. กาญจนาภิเษก แขวง บางบอน เขตบางบอน กรุงเทพมหานคร 10150'
          },
          {
            text: 'กัลปพฤกษ์ (JF)',
            desc: `📍กัลปพฤกษ์ (JF)📍`,
            value: 'กัลปพฤกษ์ (JF)',
            location: [
              {
                lat_long: '13.703614387449818, 100.44622539737809',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop5',
            timePeriod: '10:00 - 15:00',
            displayString: '16/3 ถนน กัลปพฤกษ์ แขวง บางขุนเทียน เขตจอมทอง กรุงเทพมหานคร 10150'
          },
          {
            text: 'กัลปพฤกษ์ (HP)',
            desc: `📍กัลปพฤกษ์ (HP)📍`,
            value: 'กัลปพฤกษ์ (HP)',
            location: [
              {
                lat_long: '13.695236978106088, 100.4361380758398',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop6',
            timePeriod: '10:00 - 15:00',
            displayString: '604 ถนน กัลปพฤกษ์ แขวง บางหว้า เขตภาษีเจริญ กรุงเทพมหานคร 10160'
          },
          {
            text: 'กัลปพฤกษ์ (PTT-MT)',
            desc: `📍กัลปพฤกษ์ (PTT-MT)📍`,
            value: 'กัลปพฤกษ์ (PTT-MT)',
            location: [
              {
                lat_long: '13.707986073281086, 100.45023882793562',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop7',
            timePeriod: '10:00 - 15:00',
            displayString: 'ถนน กัลปพฤกษ์ แขวง บางหว้า เขตภาษีเจริญ กรุงเทพมหานคร 10160'
          },
          {
            text: 'พระราม 2 (IND)',
            desc: `📍พระราม 2 (IND)📍`,
            value: 'พระราม 2 (IND)',
            location: [
              {
                lat_long: '13.66599004120337, 100.44361782569385',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop8',
            timePeriod: '10:00 - 15:00',
            displayString: '120 ถ. พระรามที่ 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
          },
          {
            text: 'พระราม 2 (ธอส)',
            desc: `📍พระราม 2 (ธอส)📍`,
            value: 'พระราม 2 (ธอส)',
            location: [
              {
                lat_long: '13.676941527721759, 100.4618235138312',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop9',
            timePeriod: '10:00 - 15:00',
            displayString: '73 พระราม 2 ซอย 30 แขวง บางมด เขตจอมทอง กรุงเทพมหานคร 10150'
          },
          {
            text: 'สาทรเหนือ (CT)',
            desc: `📍สาทรเหนือ (CT)📍`,
            value: 'สาทรเหนือ (CT)',
            location: [
              {
                lat_long: '13.725104736149751, 100.54014915699695',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop10',
            timePeriod: '10:00 - 15:00',
            displayString: 'ถ. สาทรเหนือ แขวง สีลม เขตบางรัก กรุงเทพมหานคร 10500'
          },
          {
            text: 'พระราม 4 (BC-XT)',
            desc: '📍พระราม 4 (BC-XT)📍',
            value: 'พระราม 4 (BC-XT)',
            location: [
              {
                lat_long: '13.718875251422839, 100.5690463825553',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop11',
            timePeriod: '12:00 - 16:00',
            displayString: '2929 ถนนพระรามที่ ๔ แขวง คลองตัน เขตคลองเตย กรุงเทพมหานคร 10110'
          },
          {
            text: 'พระโขนง-สุขุมวิท 99 (บจ)',
            desc: '📍พระโขนง-สุขุมวิท 99 (บจ)📍',
            value: 'พระโขนง-สุขุมวิท 99 (บจ)',
            location: [
              {
                lat_long: '13.69271004933028, 100.60770128539107',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop12',
            timePeriod: '12:00 - 16:00',
            displayString: '2999/1 ถ. สุขุมวิท แขวง บางจาก เขตพระโขนง กรุงเทพมหานคร 10260'
          },
          {
            text: 'ประดิษฐ์มนูญธรรม (PT)',
            desc: '📍ประดิษฐ์มนูญธรรม (PT)📍',
            value: 'ประดิษฐ์มนูญธรรม (PT)',
            location: [
              {
                lat_long: '13.792560628471398, 100.61066882025472',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop13',
            timePeriod: '12:00 - 16:00',
            displayString: 'QJV6+27F แขวง สะพานสอง เขตวังทองหลาง กรุงเทพมหานคร 10310'
          },
          {
            text: 'ประดิษฐ์มนูญธรรม (ES-ND)',
            desc: '📍ประดิษฐ์มนูญธรรม (ES-ND)📍',
            value: 'ประดิษฐ์มนูญธรรม (ES-ND)',
            location: [
              {
                lat_long: '13.821287960180761, 100.62541106627015',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop14',
            timePeriod: '14:00 - 18:00',
            displayString: '361 ซอย ประดิษฐ์มนูญธรรม แขวงลาดพร้าว เขตลาดพร้าว กรุงเทพมหานคร 10230'
          },
          {
            text: 'รามอินทรา (PTT-สน)',
            desc: '📍รามอินทรา (PTT-สน)📍',
            value: 'รามอินทรา (PTT-สน)',
            location: [
              {
                lat_long: '13.847092615988172, 100.64731867852707',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop15',
            timePeriod: '14:00 - 18:00',
            displayString: '27, 1 ถ. รามอินทรา แขวง รามอินทรา เขตคันนายาว กรุงเทพมหานคร 10230'
          },
          {
            text: 'รามอินทรา (PTT-กท)',
            desc: '📍รามอินทรา (PTT-กท)📍',
            value: 'รามอินทรา (PTT-กท)',
            location: [
              {
                lat_long: '13.845379171116159, 100.63645474826342',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop16',
            timePeriod: '14:00 - 18:00',
            displayString: '340 ถนน ประดิษฐ์มนูธรรม แขวง ท่าแร้ง เขตบางเขน กรุงเทพมหานคร 10220'
          },
          {
            text: 'หลักสี่ (PTT)',
            desc: '📍หลักสี่ (PTT)📍',
            value: 'หลักสี่ (PTT)',
            location: [
              {
                lat_long: '13.889100579376729, 100.5728753568575',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop17',
            timePeriod: '14:00 - 18:00',
            displayString:
              '99/115-120 ถ. แจ้งวัฒนะ แขวง ทุ่งสองห้อง เขต หลักสี่ กรุงเทพมหานคร 10210'
          },
          {
            text: 'หลักสี่ (SHLL)',
            desc: '📍หลักสี่ (SHLL)📍',
            value: 'หลักสี่ (SHLL)',
            location: [
              {
                lat_long: '13.89205596903052, 100.56229360999114',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop18',
            timePeriod: '14:00 - 18:00',
            displayString: '200/1 ถ. แจ้งวัฒนะ แขวง ทุ่งสองห้อง เขต หลักสี่ กรุงเทพมหานคร 10210'
          },
          {
            text: 'งามวงศ์วาน-พงษ์เพชร (LTGF)',
            desc: '📍งามวงศ์วาน-พงษ์เพชร (LTGF)📍',
            value: 'งามวงศ์วาน-พงษ์เพชร (LTGF)',
            location: [
              {
                lat_long: '13.8548247392373, 100.54418646793977',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop19',
            timePeriod: '14:00 - 18:00',
            displayString:
              '99/9 หมู่ที่ 3 ถนน งามวงศ์วาน ตำบลบางเขน อำเภอเมืองนนทบุรี นนทบุรี 11000'
          },
          {
            text: 'รัตนาธิเบศร์-ไทรม้า (บจ108)',
            desc: '📍รัตนาธิเบศร์-ไทรม้า (บจ108)📍',
            value: 'รัตนาธิเบศร์-ไทรม้า (บจ108)',
            location: [
              {
                lat_long: '13.874392048491998, 100.45798703509423',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop20',
            timePeriod: '14:00 - 18:00',
            displayString: '79 11-12 ซอย หมู่ 3 ตำบล บางรักน้อย อำเภอเมืองนนทบุรี นนทบุรี 11000'
          },
          {
            text: 'รัตนาธิเบศร์-บางรักใหญ่ (JF)',
            desc: '📍รัตนาธิเบศร์-บางรักใหญ่ (JF)📍',
            value: 'รัตนาธิเบศร์-บางรักใหญ่ (JF)',
            location: [
              {
                lat_long: '13.875831600000069, 100.4403315825482',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop21',
            timePeriod: '14:00 - 18:00',
            displayString: 'ถนน บางบัวทอง - สุพรรณบุรี ตำบล บางรักใหญ่ อำเภอบางบัวทอง นนทบุรี 11110'
          },
          {
            text: 'ราชพฤกษ์ (TH-W)',
            desc: '📍ราชพฤกษ์ (TH-W)📍',
            value: 'ราชพฤกษ์ (TH-W)',
            location: [
              {
                lat_long: '13.821225776710818, 100.44972888084453',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop22',
            timePeriod: '*วันพฤ 10:00 - 15:00 ,วันอื่น 14:00 - 18:00',
            displayString: '189 หมู่ที่ 2 ถนน ราชพฤกษ์ ตำบล บางขุนกอง อำเภอบางกรวย นนทบุรี 11130'
          },
          {
            text: 'พระรามสอง-พันท้ายนรสิงห์',
            desc: '📍พระรามสอง-พันท้ายนรสิงห์📍',
            value: 'พระรามสอง-พันท้ายนรสิงห์',
            location: [{ lat_long: '13.593112, 100.368572', id: '2021-08-30T05:38:54.613Z' }],
            shopCharg: 30,
            filterName: 'drop23',
            timePeriod: '10:00 - 15:00',
            displayString: 'ตำบล พันท้ายนรสิงห์ อำเภอเมืองสมุทรสาคร สมุทรสาคร 74000'
          },
          {
            text: '48 Factory & Co. Croissant x Coffee',
            desc: '📍48 Factory & Co. Croissant x Coffee📍โทร 081-818-6961',
            value: '48 Factory & Co. Croissant x Coffee',
            location: [
              {
                lat_long: '13.602564490444195, 100.35985429723608',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop24',
            timePeriod: '',
            displayString: '48/13 ม.1 ซ.เลียบคลอง ถ. พระราม 2 ตำบล บางน้ำจืด เมือง สมุทรสาคร 74000'
          },
          {
            text: 'โอ้กะจู๋ พระราม 2',
            desc: '📍โอ้กะจู๋ พระราม 2📍โทร 065-415-7999',
            value: 'โอ้กะจู๋ พระราม 2',
            location: [
              {
                lat_long: '13.667849590401884, 100.44943022668453',
                id: '2021-08-30T05:38:54.613Z'
              }
            ],
            shopCharg: 30,
            filterName: 'drop25',
            timePeriod: '',
            displayString:
              'เลขที่ 33 SB Design Square ชั้น G ห้องเลขที่ G104, ถ. พระราม 2 แขวง ท่าข้าม เขตบางขุนเทียน กรุงเทพมหานคร 10150'
          }
        ],
        loading: false
      }
    }
  },
  components: {
    Editable,
    PrintCover,
    PrintAllCovers,
    Multiselect,
    Nl2br,
    PrintAllCoversCentral,
    SelectGmap,
    CityFreshShippingDate,
    uploadfile
  },
  computed: {
    remarkToDriver() {
      var options = [
        {
          label:
            'รบกวนโทรหาปลายทางก่อนออกจัดส่งด้วยนะคะ และแจ้งปลายทาง ให้นำสินค้าเข้าตู้เย็นทันที เมื่อส่งให้ปลายทางแล้ว เนื่องจากสินค้าเป็นของสด ต้องการความเย็น',
          value:
            'รบกวนโทรหาปลายทางก่อนออกจัดส่งด้วยนะคะ และแจ้งปลายทาง ให้นำสินค้าเข้าตู้เย็นทันที เมื่อส่งให้ปลายทางแล้ว เนื่องจากสินค้าเป็นของสด ต้องการความเย็น'
        },
        {
          label: 'Other',
          value: 'Other'
        }
      ]

      return options
    },
    orderPayOptions() {
      var options = [
        {
          label: this.$t('เก็บเงินปลายทาง'),
          value: 'cod'
        },
        {
          label: this.$t('โอนเงิน'),
          value: 'payment'
        }
      ]

      return options
    },
    orderStatusOptions() {
      if (this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)) {
        return ACOMMERCE_STATUS_OPTIONS.map((status) => ({
          label: this.$t(`ACOMMERCE_${status}`),
          value: status
        }))
      } else {
        return STATUS_OPTIONS.map((status) => ({
          ...status,
          label: this.$t(status.label)
        }))
      }
    },
    foodguruOrderStatusOptions() {
      var options = [
        {
          label: 'Reviewing',
          value: 'Reviewing'
        },
        {
          label: 'Payment สำเร็จ',
          value: 'Payment สำเร็จ'
        },
        {
          label: 'เปิดบิลสำเร็จ',
          value: 'เปิดบิลสำเร็จ'
        },
        {
          label: 'ส่งของสำเร็จ',
          value: 'ส่งของสำเร็จ'
        }
      ]

      return options
    },
    dtacGamingOrderStatusOptions() {
      let order = this.order
      let options = [
        {
          label: 'จ่ายแล้ว',
          value: 'paid'
        },
        {
          label: 'เติมแล้ว',
          value: 'refilled',
          $isDisabled: order.note ? false : true
        },
        {
          label: 'แก้ไข',
          value: 'modify',
          $isDisabled: order.status !== 'refilled' ? true : false
        }
      ]

      return options
    },
    jsonValue() {
      try {
        if (this.order && this.order.jsonvalue) {
          return JSON.parse(this.order.jsonvalue)
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    isCheck() {
      return this.cbAll && this.cbAll.includes(this.order.id)
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    shippingAddressPosition() {
      if (this.order.nameaddress && this.order.nameaddress !== '') {
        var regex = /[\d.]+?[,][\d.]+/g
        if (this.order.nameaddress.match(regex)) {
          var resultMatch = this.order.nameaddress.match(regex)
          var position = resultMatch[0].split(',')
          if (position.length > 1) {
            return {
              lat: position[0],
              lng: position[1]
            }
          }
        }
      }
      return this.order.nameaddress
    },
    orderDetailFormat: {
      get() {
        var text = ''
        try {
          text = JSON.parse(this.order.productdetail)
        } catch (error) {
          text = this.order.productdetail
        }
        return text
      },
      set(value) {
        if (typeof value == String) {
          this.$set(this.order, 'productdetail', value)
        } else {
          this.$set(this.order, 'productdetail', JSON.stringify(value))
        }
      }
    },
    order: {
      get() {
        const vm = this
        if (['foodguru'].includes(this.selectedBot.theme)) {
          try {
            vm.status = vm.foodguruOrderStatusOptions.find(function (element) {
              return element.value == vm.value.status
            })
          } catch (error) {}
        } else if (['dtac-gaming'].includes(this.selectedBot.type)) {
          try {
            vm.status = vm.dtacGamingOrderStatusOptions.find(function (el) {
              return el.value == vm.value.status
            })
          } catch (error) {}
        } else {
          try {
            vm.status = vm.orderStatusOptions.find(function (element) {
              return element.value == vm.value.status
            })
          } catch (error) {}
        }

        return vm.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    tags: function () {
      var tags = []
      if (this.order.tags && this.order.tags.trim() != '') {
        tags = this.order.tags.split(',')
      }
      return tags
    },
    shippingType() {
      return this.handleGetShippingType()
    }
  },
  mounted() {
    if (this.order.order_json) {
      this.order_json = JSON.parse(this.order.order_json)
      if (this.order_json) {
        if (this.order_json.specialRequests && this.order_json.specialRequests[0] === 'COD')
          this.statusPay = {
            label: this.$t('ชำระปลายทาง'),
            value: 'cod'
          }
        if (this.order_json.deliveries)
          this.driverRemark = JSON.parse(this.order.order_json).deliveries[0].remarks
        this.nameEdit = JSON.parse(this.order.order_json).deliveries[0].toContact.name
      }
    }

    if (this.order && this.shippingOptions) {
      this.shippingValue = this.handleGetShippingType()
    }

    if (
      ['176922345693076', '809510349133469', '103876431747147'].includes(this.selectedBot.pageid)
    ) {
      var order = this.orderDetailFormat.find((el) => {
        return el.cart_remark != '' || el.cart_remark != null
      })

      if (order) {
        this.cart_remark = order.cart_remark
      }
    }
    var beginningTime = moment()
    var endTime = moment('9:00pm', 'h:mma')

    this.mindate = beginningTime.isBefore(endTime)
      ? moment().add('2', 'days').format('YYYY-MM-DD')
      : moment().add('3', 'days').format('YYYY-MM-DD')

    this.afterMounted()
  },
  methods: {
    handleGetShippingType() {
      let shippingType = ''
      try {
        let jsondata = JSON.parse(this.order.shippingtype)

        shippingType = jsondata.type ? jsondata.type : ''
      } catch (error) {
        shippingType = this.order.shippingtype
      }
      let shippingValue = null
      try {
        shippingValue = this.shippingOptions.find((el) => {
          return el.name == shippingType || shippingType == el[4]
        })
      } catch (error) {
        console.error(error)
      }
      return shippingValue
    },
    changeLocation(payload) {
      this.$store.dispatch('loading')
      this.order_json.stops[1].location.lat = payload.location.lat.toString()
      this.order_json.stops[1].location.lng = payload.location.lng.toString()
      this.order_json.stops[1].addresses.th_TH.displayString =
        this.name + ' , ' + payload.placesinfolabel + ' , ' + this.phoneNumber
      this.order.nameaddress =
        this.name + ' , ' + payload.placesinfolabel + ' , ' + this.phoneNumber
      this.order.order_json = JSON.stringify(this.order_json)
      this.editOrderApi(this.order)
    },
    editAddress(summaryLalamove) {
      if (summaryLalamove.nameaddress && typeof summaryLalamove.nameaddress === 'string') {
        this.phoneNumber = summaryLalamove.nameaddress.split(' , ')[2]
        this.name = summaryLalamove.nameaddress.split(' , ')[0]
      }
      if (summaryLalamove.order_json) {
        this.order_json = JSON.parse(summaryLalamove.order_json)
        this.showToAddress = true
      }
    },
    editOrderApi(dataEdit) {
      var vm = this
      api.editNvbbOrderSummary(dataEdit, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.$store.dispatch('loading')
      })
    },
    editAddressHub(hubSelect) {
      let hubAddress = null
      this.nvbb.hubLocationOptions.filter((item) => {
        if (item.value == hubSelect) {
          hubAddress = item
        }
      })

      this.dataEdit.remark = `${hubAddress.text} \n ${hubAddress.desc} \n ${hubAddress.link}`
      this.editOrderApi(this.dataEdit)
      this.toggleHub = false
      this.$store.dispatch('loading')
    },
    editAddressDroppoint() {
      var vm = this
      if (vm.droppointSelect) {
        vm.$store.dispatch('loading')
        var drop = vm.nvbb.droppointLocationOptions.find(function (element) {
          return element.value == vm.droppointSelect
        })
        if (
          drop.location &&
          drop.location[0].lat_long &&
          typeof drop.location[0].lat_long === 'string'
        ) {
          vm.order_json.stops[0].location.lat = drop.location[0].lat_long.split(', ')[0]
          vm.order_json.stops[0].location.lng = drop.location[0].lat_long.split(', ')[1]
        }
        vm.order_json.stops[0].addresses.th_TH.displayString = drop.displayString
        vm.order_json.filterName = drop.filterName

        let customerPhone =
          vm.order.nameaddress.split(' , ')[vm.order.nameaddress.split(' , ').length - 1]
        if (customerPhone.charAt(0) == '0') {
          customerPhone = customerPhone.slice(1)
          customerPhone = '+66' + customerPhone
        }
        vm.order_json.deliveries[0].toContact.phone = customerPhone

        vm.dataEdit.order_json = JSON.stringify(vm.order_json)
        vm.dataEdit.remark =
          drop.text + ' ' + drop.desc + ' ช่วงเวลาจัดส่งประมาณ ' + drop.timePeriod
        vm.editOrderApi(vm.dataEdit)
        vm.nameEdit = vm.order.nameaddress.split(' , ')[0] || ''
        vm.editName()
        vm.toggleDroppoint = false
      }
    },
    toggleDroppointClick(item) {
      var vm = this
      this.dataEdit = item
      this.order_json = JSON.parse(item.order_json) || {
        serviceType: 'MOTORCYCLE', // fix
        specialRequests: ['LALABAG'],
        stops: [
          {
            location: {
              lat: null, // lat ร้านค้า
              lng: null // lng ร้านค้า
            },
            addresses: {
              th_TH: {
                displayString: null,
                market: 'TH_BKK' // fix
              }
            }
          },
          {
            location: {
              lat: null, // lat ลูกค้า
              lng: null // lng ลูกค้า
            },
            addresses: {
              th_TH: {
                displayString: null,
                market: 'TH_BKK' // fix
              }
            }
          }
        ],
        requesterContact: {
          name: 'คุณสายชล (รถโตโยต้า สีขาว 5950)',
          phone: '+66628844598'
        },
        deliveries: [
          {
            toStop: 1, // fix
            toContact: {
              name: this.name || 'null',
              phone: this.phoneNumber
            },
            remarks: '' // ข้อความถึงคนขับ
          }
        ]
      }
      var drop = vm.nvbb.droppointLocationOptions.find(function (element) {
        return element.filterName == vm.order_json.filterName
      })
      if (drop) {
        this.droppointSelect = drop.value
      }
      this.toggleDroppoint = true
    },
    allowedDates(val) {
      if (this.nvbb.shippingType == 'express') {
        let postcode = null
        try {
          if (!this.nvbb.shippingAddress) throw new Error('Not found address')
          postcode = this.nvbb.shippingAddress.trim().match(/[1-9]{1}[0-9]{4}$/)
          if (postcode && postcode.length > 0) {
            postcode = postcode[0].trim()
          } else if (!postcode) {
            throw new Error('Not found postcode')
          } else {
            throw new Error('Many postcode')
          }
        } catch (error) {
          console.error(error)
          postcode = false
        }

        if (!postcode) {
          return false
        }
        let location = getBangkokLocation(postcode, this.nvbb.shippingAddress)
        const days = ['2', '3', '4', '6']
        // อังคาร พุธ พฤ ส
        if (['BKK', 'MET', 'REM'].includes(location)) {
          return days.includes(moment(val).weekday().toString())
          //scg
        } else {
          return days.includes(moment(val).weekday().toString())
          //interexpress
        }
      }

      return ['2', '4', '6'].includes(moment(val).weekday().toString()) // other
    },
    cancelMoveTo() {
      this.orderToMove = null
      this.showMoveToOrder = false
    },
    async moveToPreorder(order) {
      try {
        let nameaddress = order.nameaddress ? order.nameaddress.split(',') : []
        if (nameaddress.length >= 3) {
          nameaddress.splice(0, 1)
          nameaddress.splice(nameaddress.length - 1, 1)
          this.nvbb.shippingAddress = nameaddress.join(',')
        }

        let products = JSON.parse(order.productdetail)
        if (products && products.length > 0) {
          let result = products
            .map((el) => {
              if (el.sku) {
                let sku = el.sku.split('_')
                if (sku.length == 2) {
                  let product_name = sku[0],
                    stock_name = sku[1]

                  return {
                    photourl: el.photourl,
                    name: product_name,
                    option: stock_name,
                    quantity: el.quantity
                  }
                }
              }
              return false
            })
            .filter((el) => el != false)

          if (result && result.length > 0) {
            this.orderToMove = _.cloneDeep(order)
            this.orderToMove.productdetail = result
            this.showMoveToOrder = true
            return false
          }
        }
        await this.$swal.fire({
          title: this.$t('ไม่สามารถโอนย้ายไปยัง Pro-order ได้?'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      } catch (error) {
        console.error(error)
      }
    },
    async onProceedNvbbPreorder(order) {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.nvbb.loading = true
      let customerName = '',
        customerPhone = '',
        shippingAddress = '',
        shippingType

      try {
        let nameaddress = order.nameaddress ? order.nameaddress.split(',') : []
        if (nameaddress.length >= 3) {
          customerName = nameaddress[0]
          nameaddress.splice(0, 1)
          customerPhone = nameaddress[nameaddress.length - 1]
          nameaddress.splice(nameaddress.length - 1, 1)
          shippingAddress = nameaddress.join(',')
        }
        var address = customerName + ' , ' + shippingAddress + ' , ' + customerPhone
        var cart = order.productdetail

        var hubAddress = ''
        let hublocation
        if (['hub', 'hub+msg'].includes(this.nvbb.shippingType)) {
          hublocation = this.nvbb.hubLocationOptions.find((el) => {
            return el.value == this.nvbb.hubLocation
          })

          if (hublocation) {
            hubAddress = `${hublocation.text} \n${hublocation.desc} \n${hublocation.link}`
          }

          if (this.nvbb.shippingType == 'hub+msg') {
            hubAddress = hubAddress + ' (HUB to home)'
          }
        } else if (this.nvbb.shippingType == 'drop') {
          hublocation = this.nvbb.droppointLocationOptions.find((el) => {
            return el.value == this.nvbb.hubLocation
          })

          if (hublocation) {
            hubAddress = `${hublocation.text || ''} \n${hublocation.desc || ''} \n${
              hublocation.link || ''
            }`
          }
        }

        if (['hub', 'hub+msg'].includes(this.nvbb.shippingType)) shippingType = 'hub'
        else if (['express'].includes(this.nvbb.shippingType)) {
          let postcode = null
          try {
            shippingAddress = shippingAddress ? shippingAddress.trim() : ''
            postcode = shippingAddress.match(/[ ][1-9]{1}[0-9]{4}$/)
            if (postcode && postcode.length > 0) {
              postcode = postcode[0].trim()
            } else {
              throw new Error('Many postcode')
            }
          } catch (error) {
            console.error(error)
            postcode = false
          }

          if (!postcode) {
            this.nvbb.loading = false
            return false
          }
          let location = getBangkokLocation(postcode, shippingAddress)

          if (['BKK', 'MET'].includes(location)) {
            shippingType = 'scg'
          } else {
            shippingType = 'interexpress'
          }
        } else shippingType = this.nvbb.shippingType

        var request = {
          cart: cart,
          pageid: this.selectedBot.pageid,
          userid: order.userid,
          address: address,
          shippingdate: this.nvbb.pickupdate
            ? moment(this.nvbb.pickupdate).format('YYYY-MM-DD')
            : null,
          shippingtype: shippingType,
          phone: customerPhone.trim(),
          name: customerName.trim(),
          remark: hubAddress,
          shippingcharge: this.calculateShippingPrice(order),
          from: 'livechat',
          isCutQuota: false
        }

        var response = await axios.post(config.serverUrl + 'nvbbbanktransfernotify', request, {
          headers: { AUTHORIZATION: 'Bearer xxx xxx' }
        })
        if (response.data.responsecode == 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
          this.showMoveToOrder = false
          this.orderToMove = false
        }
      } catch (error) {
        console.error(error)
      }

      this.nvbb.loading = false
    },
    calculateShippingPrice(order) {
      //
      let producttype = ['phytosmooz', 'phytomylk', 'phytoshot', 'none', 'other']
      let rate = 0

      // return {small: 0, large: 0};
      var bottles = {}
      producttype.forEach((el) => {
        bottles[el] = { small: 0, large: 0 }
      })

      let total = order.productdetail
        .map((el) => {
          let type, bottles
          let option = el.option.toLowerCase().split('-')
          if (producttype.includes(option[0])) {
            type = option[0]
            bottles = { small: 0, large: 0 }
            switch (option[1]) {
              case 'ขวดเล็ก':
                bottles = { small: el.quantity, large: 0 }
                break
              case 'ขวดใหญ่':
                bottles = { small: 0, large: el.quantity }
                break

              default:
                break
            }
          }
          return {
            name: el.name,
            type: type,
            bottle: bottles
          }
        })
        .reduce(
          (prev, cur) => {
            try {
              var type = cur.type.toLowerCase()

              if (prev[type] === undefined) {
                // eslint-disable-next-line no-undef
                prev[type] = _.cloneDeep(cur.bottle)
              } else {
                prev[type].small = prev[type].small + cur.bottle.small
                prev[type].large = prev[type].large + cur.bottle.large
              }
            } catch (error) {
              console.error(error)
            }
            return prev
          },
          { ...bottles }
        )

      let totalBottle = producttype
        .map((el) => {
          if (el == 'phytoshot') {
            return (total[el].large + total[el].small) / 2
          } else if (total[el] !== undefined) {
            return total[el].large + total[el].small
          } else return null
        })
        .filter((el) => {
          return el != null
        })
        .reduce((prev, curr) => {
          return prev + curr
        }, 0)
      try {
        rate = calculateShippingPrice({
          type: this.nvbb.shippingType,
          address: this.nvbb.shippingAddress,
          total: totalBottle
        })
        if (rate != false) return Math.ceil(rate)
        return rate
      } catch (error) {
        return false
      }
    },
    afterMounted() {},
    onSelectShipping(val) {
      this.order.shippingtype = val.name
      this.$emit('input', this.order)
      this.$emit('onChangeStatus')
    },
    getOrderById(id) {
      return new Promise((resolve, reject) => {
        api.getordersbyid({ id: id, pageid: this.selectedBot.pageid }, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    async onPrinCover(allcontents, payload) {
      var orders = []
      if (allcontents) {
        var response = await this.getOrderById(this.order.id)
        orders = response.data ? response.data : []
      } else orders = [this.order]
      payload.printPdf(orders)
    },
    onImageLoadFailure(event) {
      event.target.src = '/static/img/assets/payment/other_charge_logo.png'
    },
    assignCb(id) {
      this.$emit('assignCb', id)
    },
    onSelectOrderStatus: async function (status) {
      var order = this.order

      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        let data = {
          pageid: this.selectedBot.pageid,
          orderid: this.order.id
        }
        if (status.value != 'canceled' && order.status == 'canceled') {
          data.type = 'DELETE'
          await api.nvbb_pre_order_stock_update(data)
        } else if (order.status != 'canceled' && status.value == 'canceled') {
          data.type = 'ADD'
          await api.nvbb_pre_order_stock_update(data)
        }
      } else if (!['1227843817265057'].includes(this.selectedBot.pageid)) {
        if (status.value != 'canceled' && order.status == 'canceled') {
          api.orderstockdelete({ orderid: this.order.id }, () => {})
        } else if (order.status != 'canceled' && status.value == 'canceled') {
          api.orderstockadd({ orderid: this.order.id }, () => {})
        }
      }

      order.status = status.value
      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    onSelectOrderPay: async function (statusPay) {
      var order = this.order
      var order_json = JSON.parse(order.order_json)
      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        if (statusPay) {
          order_json.specialRequests = ['COD', 'LALABAG']
        } else {
          order_json.specialRequests = ['LALABAG']
        }
        order.order_json = JSON.stringify(order_json)
      }
      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    editRemarks() {
      this.onSelectRemarkToDriver(this.driverRemark)
    },
    editName() {
      var order = this.order
      var order_json = JSON.parse(order.order_json)
      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        if (this.nameEdit) {
          var name = ''
          order_json.deliveries[0].toContact.name = this.nameEdit
          if (order.nameaddress && typeof order.nameaddress === 'string') {
            order.nameaddress.split(' , ').map((item, i) => {
              if (i !== 0 && i !== order.nameaddress.split(' , ').length - 1) {
                name += item + ' , '
              } else if (i === order.nameaddress.split(' , ').length - 1) {
                name += item
              }
            })
          }
          order.nameaddress = this.nameEdit + ' , ' + name
          order.order_json = JSON.stringify(order_json)
        }
      }

      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },

    onSelectRemarkToDriver(driverRemark) {
      var order = this.order
      var order_json = JSON.parse(order.order_json)
      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        if (driverRemark.value) {
          order_json.deliveries[0].remarks = driverRemark
        }
        order.order_json = JSON.stringify(order_json)
      }

      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    onCityfreshUpdateShippingdate(val) {
      let order = this.order
      order.shipping_date = val.shipping_date
      order.shipping_time = val.shipping_time
      this.$emit('updateOrder', 'save')
    },
    handleUploadedReceipt() {
      let order = this.order
      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    async handleSendReceipt() {
      this.$store.dispatch('loading')
      try {
        await dtacGamingApi.postSendReceipt({
          data: {
            page_id: this.selectedBot.pageid,
            order_id: this.order.id
          }
        })
        await this.$swal.fire({
          title: this.$t('Success'),
          type: 'success',
          confirmButtonText: this.$t('Confirm')
        })
      } catch (error) {
        console.log(error)
      }
      this.$store.dispatch('loading')
    }
  },
  watch: {
    cbAll(newVal, oldVal) {
      if (this.cbAll && this.cbAll.includes(this.order.id)) this.cb = true
      else this.cb = false
    },
    showPrint: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    order(newVal) {
      if (newVal) {
        this.shippingValue = this.handleGetShippingType()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ecommerce/OrderSummaryItem.js